import { createContext } from "react";
import AuthenticationResponse from "../../../models/interfaces/authentication-response";

export interface AuthenticationContextProps {
    authenticationResponse: AuthenticationResponse | null;
    setAuthenticationResponse: (
        authenticationResponse: AuthenticationResponse | null,
    ) => void;
    resetAuthenticationContext: () => void,
    refetchCookieSession: () => Promise<boolean>,
    hasLicencePermission: (permission: string) => boolean
}

export const AuthenticationContext = createContext<AuthenticationContextProps>(
    {
        authenticationResponse: null, setAuthenticationResponse: () => {/* default value */ },
        resetAuthenticationContext: () => {/* default value */ },
        refetchCookieSession: () => Promise.resolve(false) /* default value */,
        hasLicencePermission: () => false /* default value */
    });

export default AuthenticationContext;